import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
let _ = require('lodash');
export default {
  data() {
    return {
      heightdata: false,
      List: [],
      defaultdataList: [],
      formObj: {
        map_type2: '',
        place_name: ''
      },
      listStyle: {},
      upFlag: false,
      loading: true,
      typeoptions: []
    };
  },
  components: {},
  watch: {
    '$attrs.formoption': {
      handler(val) {
        if (val) this.getTypeOptions(val);
      },
      deep: true
    },
    '$attrs.datalist': {
      handler(val) {
        this.List = [...val];
        this.defaultdataList = [...val];
        if (this.List.length > 0) this.loading = false;
      },
      deep: true
    },
    '$attrs.style': {
      handler(val) {
        this.listStyle = {
          ...val
        };
        delete this.listStyle.width;
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    getTypeOptions(data) {
      this.typeoptions = [];
      if (data.length > 0) {
        data.forEach(elem => {
          let item = elem.itemformdata;
          let obj = {
            value: item.title,
            label: item.title,
            children: []
          };
          // console.log(item);
          if (item.json && item.json.length > 0) {
            let children = [...JSON.parse(item.json.replace(/(<\/?p.*?>)/gi, ''))];
            let childrenArr = [];
            children.forEach(child => {
              let cobj = {
                value: child.title,
                label: child.title
              };
              childrenArr.push(cobj);
            });
            obj.children = childrenArr;
          }
          this.typeoptions.push(obj);
        });
        // console.log(`this.typeoptions`, this.typeoptions);
      }
    },
    gosearch() {
      let filters = {};
      Object.keys(this.formObj).forEach(item => {
        filters[item] = this.formObj[item] === '' || this.formObj[item] === null ? [] : typeof this.formObj[item] === 'string' ? this.formObj[item] : this.formObj[item].join('/');
      });
      let cacheData = _.cloneDeep(this.defaultdataList);
      let filterArray = this.multiFilter(cacheData, filters);
      let data = JSON.parse(JSON.stringify(filterArray));
      this.List = data;
    },
    // 静态数据筛选
    multiFilter(array, filters) {
      const filterKeys = Object.keys(filters);
      return array.filter(item => {
        let itemflag = filterKeys.every(key => {
          // 自定义判断
          if (key === 'place_name') {
            return !!~item.itemformdata[key].indexOf(filters[key]);
          }
          if (!filters[key].length) return true;
          return !!~filters[key].indexOf(item.itemformdata[key]);
        });
        return itemflag;
      });
    },
    listmarkerclick(item) {
      this.$emit('listclick', item);
    },
    listUp() {
      this.upFlag = !this.upFlag;
      this.$emit('listup', this.upFlag);
    },
    listDown() {
      this.upFlag = false;
    }
  }
};